import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  List,
  ListItemButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { BREAK_TIME } from '@src/constants/voice';
import { CancelRounded, CheckRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import {
  StyledDrawer,
  StyledListItem,
  StyledSpeedDrawer,
} from './index.styled';

const BREAK_TIME_LIMIT = {
  MIN: 0.25,
  MAX: 60,
};

const BreakTimeDrawer = ({ open, onClose, onChange }) => {
  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState('');

  const handleSelectedValue = (value) => {
    if (onChange) onChange(value);
    onClose();
  };

  const handleInputSubmit = () => {
    let value = parseFloat(inputValue);
    if (value <= BREAK_TIME_LIMIT.MIN) value = BREAK_TIME_LIMIT.MIN;
    if (value > BREAK_TIME_LIMIT.MAX) value = BREAK_TIME_LIMIT.MAX;
    handleSelectedValue(value);
    setInputValue('');
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    setInputValue(value);
  };

  return (
    <StyledDrawer
      title={t('breakTimeTitle')}
      anchor="bottom"
      open={open}
      onClose={onClose}
    >
      <Box className="drawer-title">
        <span className="title">{t('breakTimeTitle')}</span>
        <CancelRounded sx={{ color: COLOR.darkV2[32] }} onClick={onClose} />
      </Box>
      <StyledSpeedDrawer
        minValue={BREAK_TIME_LIMIT.MIN}
        maxValue={BREAK_TIME_LIMIT.MAX}
        inputValue={inputValue}
      >
        <List>
          {BREAK_TIME.map((item) => (
            <StyledListItem key={item} className="list-item">
              <ListItemButton
                onClick={() => {
                  handleSelectedValue(item);
                }}
              >
                <div className="item-break-time">{item}s</div>
              </ListItemButton>
            </StyledListItem>
          ))}
        </List>

        <Box className="speed-input-container">
          <TextField
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                handleInputSubmit();
              }
            }}
            placeholder={t('inputBreakTimePlaceholder', {
              value: BREAK_TIME_LIMIT.MAX,
            })}
            className="break-time-input"
            type="number"
            InputProps={{
              inputProps: { min: 0, max: 60, step: 0.01, lang: 'en' },
              endAdornment: inputValue && (
                <InputAdornment position="end">
                  <CheckRounded
                    className="icon-choose-speed-input"
                    onClick={handleInputSubmit}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </StyledSpeedDrawer>
    </StyledDrawer>
  );
};

export default BreakTimeDrawer;
